import { combineReducers } from 'redux'
import setUsuario from './setUsuario'
import setLottery from './setLottery'
import setMarketplace from './setMarketplace'
import setListUsuario from './setListUsuario'
import setTicket from './setTicket'
import setReward from './setReward'
import setRol from './setRol'

export default combineReducers({
    usuario: setUsuario,
    lotteries: setLottery,
    marketplaces: setMarketplace,
    usuarios: setListUsuario,
    tickets: setTicket,
    rewards: setReward,
    roles: setRol,
})